module.exports = __webpack_public_path__ + "static/Lora-Italic-ab2098e1bf41df6b514fdf1f3d4f30b0.ttf";